export default "__VITE_ASSET__f8f4b533__"